import type { AccountNode } from '@taler/api-client'
import { type Locale, resolveLocalized } from '@taler/domain'

export interface AccountOption {
  readonly id: string
  readonly label: string
  readonly currency: string | undefined
}

function label(account: AccountNode['account'], locale: Locale): string {
  return resolveLocalized(account.names, locale)?.name ?? account.code
}

/** A job's own account: additionally a currency-bearing ASSET/LIABILITY account
 * (`ImportService.requireJobAccount`) - both postings of every entry the job commits carry it. */
export function flattenStatementAccounts(
  nodes: readonly AccountNode[],
  locale: Locale,
): readonly AccountOption[] {
  const out: AccountOption[] = []
  const walk = (candidates: readonly AccountNode[]): void => {
    for (const node of candidates) {
      const { account } = node
      if (
        account.isPostable &&
        account.archivedAt === undefined &&
        account.currency !== undefined &&
        (account.accountClass === 'ASSET' || account.accountClass === 'LIABILITY')
      ) {
        out.push({ id: account.id, label: label(account, locale), currency: account.currency })
      }
      walk(node.children)
    }
  }
  walk(nodes)
  return out
}
